export default __webpack_public_path__ + "static/media/HIE.5f931a83.svg";